import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { setSucursal } from '../../Redux/actions/PageActions';
import { useSelector } from 'react-redux';

//axios
import axios from 'axios'

//constantes
import * as Constant from '../../global/const'
import auth from '../../Helpers/auth'
import ModalSucursales from '../Sucursal/modalSucursales.component'

//imagenes
// import sucursal from '../../assets/icons/sucursal.svg'

const SucursalComponent = ({ close, setclose, myRef }) => {

    const dispatch = useDispatch();
    const CambiarSucursal = sucursal => dispatch(setSucursal(sucursal));
    const sucursal = useSelector(state => state.page.sucursal);
    const [sucursales, setSucursales] = useState([]);
    const [sucursalesAll, setsucursalesAll] = useState([]);
    const user = JSON.parse(auth.getUsuario());
    let count = 0;

    const [fechaEntrega, setFechaEntrega] = useState()

    const getFechaEntrega = () => {
        axios.get(Constant.FECHAENTREGA + `?codigo=${sucursal.codigo}&nit=${sucursal.nit}&agencia=${sucursal.agencia}`)
            .then((response) => {
                setFechaEntrega(response.data)
            }).catch((err) => {
                console.log(err);
            })
    }


    const getSucursales = () => {
        const sucursalCurrent = JSON.parse(localStorage.getItem('sucursal'));

        axios.get(Constant.GETSUCRUSALES  + "?correo=" + user.email)
            .then(
                (response) => {
                    setsucursalesAll(response.data);
                    const arraySearch = Array.from(response.data)
                    let surcursalesAct = arraySearch.splice(0, 6);
                    setSucursales(surcursalesAct)
                    !sucursal
                        &&
                        CambiarSucursal(sucursalCurrent ? sucursalCurrent : surcursalesAct[0])
                }
            ).catch((err) => {
                console.log("sucursales ", err);
            })
    }


    useEffect(() => {
        getSucursales();
        // getFechaEntrega();
    }, [])

    useEffect(() => {
        if (sucursal) {
            getFechaEntrega();
        }
    }, [sucursal])

    return (
        <>
            {
                user.tipoClienteUsuario === 1
                    ?
                    (
                        <div
                            className="select-sucursales select-css activar"
                            onClick={() => setclose(!close)}
                        >
                            <img
                                src={sucursal}
                                alt=""
                                onClick={
                                    () => { setclose(!close) }
                                }
                            />
                            <h4 className="sucursal activar" >
                                {
                                    sucursal
                                        ?
                                        sucursal.razonsocial
                                        : ""
                                }

                            </h4>
                        </div>
                    )
                    :
                    (
                        <div className="select-sucursales select-css-tipo2 activar" >
                            <h4 className="sucursal activar" >
                                Entregas:
                                {
                                    /**fehcaEntrega ? fechaEntrega.texto : "" */
                                    fechaEntrega ? sucursal.diaEntrega : ""
                                }
                            </h4>
                        </div>
                    )
            }
            {
                user.tipoClienteUsuario === 1
                &&
                <ModalSucursales
                    myRef={myRef}
                    close={close}
                    setClose={setclose}
                    sucursales={sucursales}
                    setSucursales={setSucursales}
                    sucursalesAll={sucursalesAll}
                />
            }
        </>
    )
}

export default SucursalComponent;